<template>
  <transition name="subscription-modal">
    <div
      v-if="subscription_expired_modal"
      cy="subscription-expired-modal"
      class="subscription-modal-root"
    >
      <div
        cy="subscription-modal-overlay"
        class="subscription-modal-overlay"
        @click.self.prevent
      />
      <div class="subscription-modal-card" role="dialog" aria-modal="true" aria-labelledby="subscription-modal-title">
        <img
          cy="subscription-modal-logo"
          class="subscription-modal-logo"
          :src="logo"
          alt="ASP"
        />

        <h2 cy="subscription-modal-title" id="subscription-modal-title" class="subscription-modal-title">
          Abonamentul a expirat
        </h2>

        <p cy="subscription-modal-message" class="subscription-modal-message">
          Pentru a putea continua să utilizezi aplicația, te rugăm să ne contactezi la numărul de telefon:
        </p>

        <a
          cy="subscription-modal-phone"
          class="subscription-modal-phone"
          href="tel:+40743536495"
        >
          0743 536 495
        </a>

        <p class="subscription-modal-sign">
          Cu drag,<br>Echipa AutoServicePro
        </p>

      </div>
    </div>
  </transition>
</template>

<script>
  import { mapState } from 'vuex'
  import logo from '@/assets/logo.svg'

  export default {
    name: 'Subscription_Expired_Modal',
    data () {
      return {
        logo
      }
    },
    computed: {
      ...mapState({
        subscription_expired_modal: state => state.subscription_expired_modal
      })
    },
  }
</script>

<style lang="less">
  @media only screen and (min-width: 0) {
    .subscription-modal-root {
      position: fixed;
      inset: 0;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
    }

    .subscription-modal-overlay {
      position: absolute;
      inset: 0;
      background: rgba(8, 11, 20, 0.62);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
    }

    .subscription-modal-card {
      position: relative;
      width: 100%;
      max-width: 480px;
      background: #0F172A;
      color: #F8FAFC;
      border-radius: 15px;
      padding: 36px 28px 28px;
      box-shadow:
        0 24px 60px rgba(0, 0, 0, 0.55),
        0 2px 8px rgba(0, 0, 0, 0.35),
        inset 0 0 0 1px rgba(255, 255, 255, 0.06);
      text-align: center;
    }

    .subscription-modal-logo {
      display: block;
      margin: 0 auto 20px;
      height: 48px;
      width: auto;
      filter: brightness(0) invert(1);
      opacity: 0.95;
    }

    .subscription-modal-title {
      font-size: 20px;
      font-weight: 600;
      line-height: 1.3;
      margin: 0 0 12px;
      color: #F8FAFC;
      letter-spacing: -0.01em;
    }

    .subscription-modal-message {
      font-size: 14.5px;
      line-height: 1.55;
      font-weight: 500;
      color: #b7c4d5;
      margin: 0 0 20px;
    }

    .subscription-modal-phone {
      display: block;
      font-size: 22px;
      font-weight: 700;
      color: #16A34A;
      text-decoration: none;
      margin: 0 0 20px;
      letter-spacing: 0.02em;

      &:hover {
        color: #22c55e;
      }
    }

    .subscription-modal-sign {
      font-size: 14px;
      line-height: 1.5;
      color: #94a3b8;
      margin: 20px 0 0;
    }

  }

  .subscription-modal-enter-active,
  .subscription-modal-leave-active {
    transition: opacity 280ms cubic-bezier(0.16, 1, 0.3, 1);

    .subscription-modal-card {
      transition:
        transform 320ms cubic-bezier(0.16, 1, 0.3, 1),
        opacity 280ms cubic-bezier(0.16, 1, 0.3, 1);
    }
  }

  .subscription-modal-enter,
  .subscription-modal-leave-to {
    opacity: 0;

    .subscription-modal-card {
      opacity: 0;
      transform: scale(0.94) translateY(8px);
    }
  }

  .subscription-modal-enter-to,
  .subscription-modal-leave {
    opacity: 1;

    .subscription-modal-card {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .subscription-modal-enter-active,
    .subscription-modal-leave-active,
    .subscription-modal-enter-active .subscription-modal-card,
    .subscription-modal-leave-active .subscription-modal-card {
      transition: none;
    }
  }
</style>
